import React from 'react';
import {concatenate} from "../../../services/string";

type Option = 'bymonthday' | 'bysetpos'

type Props = {
    date: Date
    onChange: (option: Option, monthday: number | null, weekday: number | null, position: number | null) => any
    selected?: Option
    disabled?: boolean
}

const ordinal = (n: number): string => {
    const index = ((n + 90) % 100 - 10) % 10 - 1
    return ["st", "nd", "rd"][index] || "th"
}

function ByMonthDaySelect({date, onChange, selected, disabled}: Props) {

    const dayNumber = date.getDate()
    const dayName = date.toLocaleString('en-GB', {weekday: 'long'})
    const weekNumber = Math.ceil(dayNumber / 7)
    const weekday = date.getDay() === 0? 6 : (date.getDay() - 1)
    const nthDay = `${weekNumber}${ordinal(weekNumber)} ${dayName}`

    const selectOption = (option: Option) => {
        switch (option) {
            case "bymonthday":
                onChange(option, dayNumber, null, null)
                break

            case "bysetpos":
                onChange(option, null, weekday, weekNumber)
                break
        }
    }

    return (
        <select
            name="bymonthday"
            id="select-bymonthday"
            value={selected ?? 'bymonthday'}
            onChange={event => selectOption(event.currentTarget.value as Option)}
            className={concatenate(
              "block rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm",
              disabled ? 'cursor-not-allowed text-gray-500' : '',
            )}
            disabled={disabled}
        >
            <option value="bymonthday">{`day ${dayNumber}`}</option>
            <option value="bysetpos">{`the ${nthDay}`}</option>
        </select>
    );
}

export default ByMonthDaySelect;